import AuthService from "@/api/services/AuthService"
import * as Cookies from "js-cookie"
import Vue from "vue"

const state = () => ({
    token: Cookies.get("bearer_token") || "",
    user: null
})

const mutations = {
    AUTH_SUCCESS: (state, user) => {
        state.user = user
    },

    LOGOUT: state => {
        Cookies.remove("bearer_token")
        state.user = []
    },

    UPDATE_AUTH_USER: (state, payload) => {
        let roles = state.user.roles
        state.user = payload
        state.user.roles = roles
    }
}

const actions = {
    LOGIN: async ({ commit }, credentials) => {
        try {
            let { data, status } = await AuthService.login(credentials)
            if (status === 200) {
                let token = data.token
                Cookies.set("bearer_token", token)
            }
            return { logginSuccess: true }
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "auth",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la autenticación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status, logginSuccess: false}
            }
        }
    },

    USER_ROLES: async ({ commit }) => {
        try {
            let { data, status } = await AuthService.roles()
            if (status === 200) {
                commit("AUTH_SUCCESS", data)
                return data
            }
        } catch (error) {
            commit("LOGOUT")
            Vue.notify({
                group: "auth",
                type: "error",
                title: "Servidor",
                text: "No ha sido posible recuperar los datos del usuario. Inténtelo nuevamente"
            })
            return null
        }
    },

    LOGOUT: async ({ commit }) => {
        commit("LOGOUT")
        Vue.notify({
            group: "auth",
            type: "success",
            title: "Autenticación",
            text: "Usuario desconectado del sistema"
        })
    },

    UPDATE_AUTH_USER: async ({ commit }, payload) => {
        try {
            let { data, status } = await AuthService.change_profile(payload)
            if (status === 200) {
                commit("UPDATE_AUTH_USER", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El usuario ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_AUTH_PASSWORD: async ({ commit }, payload) => {
        try {
            let { status } = await AuthService.change_password(payload)
            if (status === 204) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La contraseña ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    }
}

const getters = {
    HAS_ROLE: state => roles => {
        let val = false
        if (state.user !== []) {
            if (state.user.roles !== undefined) {
                state.user.roles.forEach(rol => {
                    if (rol.name === "superadmin") {
                        val = true
                    }
                })

                roles.forEach(entry_rol => {
                    state.user.roles.forEach(user_rol => {
                        if (user_rol.name === entry_rol) {
                            val = true
                        }
                    })
                })
                return val
            }
        }
    },

    CURRENT_USER: state => {
        return state.user
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
